export default __webpack_public_path__ + "static/media/charte.e4f0faad.pdf";